export default {
  room: (state) => {
    return state.workstations;
  }
}
